/**
 * FikoMini3D Module Exports
 *
 * Dialog içinde tam özellikli 3D viewer için component'ler
 * FikoThreeJsComponent kullanarak ana viewer ile aynı özelliklere sahip
 */

// Full-featured embedded viewer (FikoThreeJsComponent tabanlı)
// Ana viewer ile aynı özelliklere sahip: WASM, GPU, LOD, seçim, vs.
export { FikoMini3DDialogBase, FikoKocKafaDialogComponent } from './fiko-mini-3d-dialog.component';
export { FikoOzmoKafaDialogComponent } from './fiko-ozmo-kafa-dialog.component';
export type { FikoMini3DEvent } from './fiko-mini-3d-dialog.component';

// Lightweight standalone mini viewer (opsiyonel - circular import yok)
export { FikoMini3DComponent } from './fiko-mini-3d.component';
export type { FikoMini3DEvent as FikoMini3DStandaloneEvent } from './fiko-mini-3d.component';
